import React, { useEffect, useState } from "react";
import { secureStorage } from "./utils/secureStorage";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

const VerifyEmail = () => {
  const [message, setMessage] = useState("⏳ Verifying your email...");
  const [verified, setVerified] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState(""); // for login form
  const [loginError, setLoginError] = useState("");

  useEffect(() => {
    console.log("✅ Loaded VerifyEmail component");

    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");
    console.log("Token:", token);

    if (!token) {
      setMessage("❌ No token found. Invalid verification link.");
      return;
    }

    const verify = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/verify-email?token=${token}`, {
          cache: "no-store", // force fresh request to avoid 304 cache issues
        });
        const data = await res.json();

        if (res.ok) {
          setMessage("✅ Email verified successfully! Please log in below.");
          setVerified(true);
          setEmail(data.email || ""); // prefill email if returned by backend
        } else {
          setMessage(data.detail || "❌ Email verification failed.");
        }
      } catch (err) {
        setMessage("❌ Error verifying email. Please try again later.");
      }
    };

    verify();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError("");

    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setLoginError(data.detail || "Login failed.");
        return;
      }

      // Store tokens and user info in localStorage
      secureStorage.setItem("token", data.access_token);
      secureStorage.setItem("refreshToken", data.refresh_token);
      secureStorage.setItem("role", data.role);
      secureStorage.setItem("isSuperAdmin", data.is_super_admin ? "true" : "false");

      window.location.href = "/"; // redirect to app home
    } catch (err) {
      setLoginError("Something went wrong during login.");
    }
  };

  return (
    <div className="auth-container">
      <h2>Email Verification</h2>
      <p>{message}</p>

      {verified && (
        <form onSubmit={handleLogin} style={{ marginTop: "20px" }}>
          <input
            type="email"
            className="auth-input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            className="auth-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" className="auth-button">
            Login
          </button>
          {loginError && <p className="auth-error">{loginError}</p>}
        </form>
      )}
    </div>
  );
};

export default VerifyEmail;



// import React, { useEffect, useState } from "react";

// const VerifyEmail = () => {
//   const [message, setMessage] = useState("⏳ Verifying your email...");
//   const [verified, setVerified] = useState(false);
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState(""); // for login form
//   const [loginError, setLoginError] = useState("");

//   useEffect(() => {
//     console.log("✅ Loaded VerifyEmail component");

//     const queryParams = new URLSearchParams(window.location.search);
//     const token = queryParams.get("token");
//     console.log("Token:", token);

//     if (!token) {
//       setMessage("❌ No token found. Invalid verification link.");
//       return;
//     }

//     const verify = async () => {
//       try {
//         const res = await fetch(`http://127.0.0.1:8000/verify-email?token=${token}`, {
//           cache: "no-store", // force fresh request to avoid 304 cache issues
//         });
//         const data = await res.json();

//         if (res.ok) {
//           setMessage("✅ Email verified successfully! Please log in below.");
//           setVerified(true);
//           setEmail(data.email || ""); // prefill email if returned by backend
//         } else {
//           setMessage(data.detail || "❌ Email verification failed.");
//         }
//       } catch (err) {
//         setMessage("❌ Error verifying email. Please try again later.");
//       }
//     };

//     verify();
//   }, []);

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setLoginError("");

//     try {
//       const response = await fetch("http://127.0.0.1:8000/login", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, password }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         setLoginError(data.detail || "Login failed.");
//         return;
//       }

//       // Store tokens and user info in localStorage
//       localStorage.setItem("token", data.access_token);
//       localStorage.setItem("refreshToken", data.refresh_token);
//       localStorage.setItem("role", data.role);
//       localStorage.setItem("isSuperAdmin", data.is_super_admin ? "true" : "false");

//       window.location.href = "/"; // redirect to app home
//     } catch (err) {
//       setLoginError("Something went wrong during login.");
//     }
//   };

//   return (
//     <div className="auth-container">
//       <h2>Email Verification</h2>
//       <p>{message}</p>

//       {verified && (
//         <form onSubmit={handleLogin} style={{ marginTop: "20px" }}>
//           <input
//             type="email"
//             className="auth-input"
//             placeholder="Email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             required
//           />
//           <input
//             type="password"
//             className="auth-input"
//             placeholder="Password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             required
//           />
//           <button type="submit" className="auth-button">
//             Login
//           </button>
//           {loginError && <p className="auth-error">{loginError}</p>}
//         </form>
//       )}
//     </div>
//   );
// };

// export default VerifyEmail;
